import "./index.scss";

import closeIcon from "../../../assets/close_icon.svg";

const BaseModal = ({ wrapperCls, children, withoutOverflow, close }) => (
  <div className="base-modal">
    <div className={`base-modal__container ${wrapperCls} ${withoutOverflow ? "without-overflow" : ""}`}>{children}</div>

    {close && (
      <div className="base-modal__close">
        <img src={closeIcon} onClick={close} alt="close" />
      </div>
    )}
  </div>
);

export default BaseModal;
